import { render, staticRenderFns } from "./import-export-activities.vue?vue&type=template&id=62460b54"
import script from "./import-export-activities.vue?vue&type=script&lang=js"
export * from "./import-export-activities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports